/**
 * Página principal del módulo de reportes de errores de archivos de participantes.
 *
 * Esta página proporciona la interfaz principal para gestionar y visualizar errores
 * de carga masiva de participantes, incluyendo el layout, navegación y título de la página.
 *
 * @author Victor Manuel Calle Londoño <victor.calle@iudigital.edu.co>
 * @date [Fecha de creación: 2025-08-06]
 * @updated [Fecha de última modificación: 2025-08-11]
 * @updatedBy Victor Manuel Calle Londoño <victor.calle@iudigital.edu.co>
 */

import React from "react";
import { useLocation } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { Card, Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import ParticipantFileReportsController from "./controllers/ParticipantFileReportsController";

export default function ParticipantFileReports() {
  const location = useLocation();
  const activityName = location.state?.activityTitle.activityName || "Actividad";
  const fileName = location.state?.fileName || "Archivo";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="error">
                <MDTypography variant="h3" color="white">
                  {`Reporte de Errores - ${fileName}`}
                </MDTypography>
                <MDTypography variant="body2" color="white" opacity={0.8}>
                  {`Actividad: ${activityName}`}
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <ParticipantFileReportsController />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
